import { useEffect, useState } from "react";

/**
 * Returns `true` only after `active` has stayed `true` for `delayMs`, and flips
 * back to `false` immediately when `active` becomes `false`.
 *
 * Use to defer a transient indicator (e.g. a loading spinner) so a fast response
 * that resolves before `delayMs` never causes a flash of UI.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setElapsed(false);
      return;
    }

    const timeoutId = window.setTimeout(() => setElapsed(true), delayMs);
    return () => window.clearTimeout(timeoutId);
  }, [active, delayMs]);

  return active && elapsed;
}
